import { css } from '@mui/styled-engine'
import { HAVDesignTokensInterface } from '../interfaces'
import { havH4Text, havH5Text, havSubtitleText, havDefault02Text } from './Texts'
import { theme } from 'styles/theme/hav-theme'

const havModalShape = (HAVDesignTokens: HAVDesignTokensInterface) => css`
  color: ${HAVDesignTokens.palette.neutral.medium};
  ${havSubtitleText(HAVDesignTokens)};
  h4 {
    ${havH4Text(HAVDesignTokens)};
  }

  .MuiFormControlLabel-root svg {
    color: ${HAVDesignTokens.palette.main.primary};
  }

  label {
    ${havDefault02Text(HAVDesignTokens)};
  }

  @media (max-width: 767px) {
    ${havDefault02Text(HAVDesignTokens)};

    h4 {
      ${havH5Text(HAVDesignTokens)};
    }

    button {
      height: ${theme.spacing.xl};
    }
  }

  background-color: ${HAVDesignTokens.palette.neutral.white};
  box-shadow: ${HAVDesignTokens.shape.shadow.rule.first};
  border-radius: ${HAVDesignTokens.shape.border.radius.big};
`

export { havModalShape }
